import { ScenarioFolderServer } from './server';
import { IScenarioFolder } from './client';

export const normalizeScenarioFolder = (
  raw: ScenarioFolderServer
): IScenarioFolder => ({
  id: raw._id,
  title: raw.name,
  dateCreated: new Date(raw.date_created),
  dateUpdated: new Date(raw.date_updated)
});
